/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { ReadMessageThreadResponseJson } from './read-message-thread-response-json';
import { ReadMessageThreadResult } from '../results/read-message-thread-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class ReadMessageThreadResponse extends ResponseWithErrorGeneric<ReadMessageThreadResponseJson, ReadMessageThreadResult> implements IResponseWithErrorGeneric<ReadMessageThreadResult> {
  public caseId: string = undefined;
  public updated: number = undefined;

  //<custom-body>
  constructor(response: HttpResponse<ReadMessageThreadResponse>) {
        super(response, ReadMessageThreadResult.Error);
        if (this.result === ReadMessageThreadResult.Success) {
            this.caseId = this.body.caseId;
        }
  }
  //</custom-body>
}
